const strokeMap = {
  a: [2], b: [2], c: [1, 2], d: [2], e: [1, 2], f: [1], g: [2], h: [2],
  i: [1], j: [1, 2], k: [2], l: [1, 2], m: [2, 3], n: [2], o: [2], p: [1],
  q: [2], r: [1, 2], s: [1, 2], t: [1], u: [2], v: [2], w: [3], x: [2],
  y: [1, 2], z: [1]
};

function getStrokeOptions(word) {
  return [...word.toLowerCase()].map((char, i) => {
    let base = strokeMap[char] || [1];
    if ((char === 'j' || char === 'l') && i !== 0) base = base.filter(s => s !== 2);
    if (char === 'r') base = i === 0 ? [2] : [1, 2];
    return base;
  });
}

function getStrokeTotals(word) {
  const options = getStrokeOptions(word);
  const cartesian = options.reduce((acc, curr) =>
    acc.flatMap(a => curr.map(b => a.concat(b))), [[]]
  );
  return new Set(cartesian.map(arr => arr.reduce((a, b) => a + b, 0)));
}

function areWordsCompatible(w1, w2) {
  if (w1.length < 4 || w2.length < 4 || Math.abs(w1.length - w2.length) > 2) return false;
  const totals1 = getStrokeTotals(w1);
  const totals2 = getStrokeTotals(w2);
  return [...totals1].some(t => totals2.has(t));
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ambigram-checker-container');
  if (!container) return;

  const html = `
    <div id="ambigram-checker" style="font-family: 'Helvetica Neue', sans-serif; max-width: 750px; margin: 3rem auto; background: #000; color: white; padding: 3rem; border-radius: 24px; box-shadow: 0 0 16px rgba(35, 255, 227, 0.3); border: 5px solid #23ffe3;">
      <h2 style="margin-top: 0; color: #23ffe3; font-size: 3.375rem; text-align: center;">Ambigram Compatibility Checker</h2>
      <input type="text" id="word1" placeholder="First Word or Name" style="width: 100%; margin-bottom: 1.2rem; padding: 0.9rem; font-size: 1.95rem; border-radius: 12px; border: none; background: #111; color: white;" />
      <input type="text" id="word2" placeholder="Second Word or Name" style="width: 100%; margin-bottom: 1.5rem; padding: 0.9rem; font-size: 1.95rem; border-radius: 12px; border: none; background: #111; color: white;" />
      <button id="check-btn" style="width: 100%; padding: 1.125rem; font-size: 1.95rem; background-color: #23ffe3; color: #000; border: none; border-radius: 12px; font-weight: bold; cursor: pointer;">Check Compatibility</button>
      <p id="result" style="margin-top: 1.875rem; font-size: 1.8rem; font-weight: bold; text-align: center;"></p>
      <p id="disclaimer" style="margin-top: 0.75rem; font-size: 1.35rem; text-align: center; color: #999;"></p>
      <div id="order-link" style="display: none; text-align: center; margin-top: 2.25rem;">
        <a href="https://wowtattoos.com/products/150-custom-ambigram-by-mark-mr-upsidedown-palmer" target="_blank" style="display: inline-block; padding: 1.125rem 2.25rem; font-size: 1.8rem; font-weight: bold; color: #000; background-color: #00FF88; border-radius: 12px; text-decoration: none;">Order Your Custom Ambigram</a>
      </div>
    </div>
  `;

  container.innerHTML = html;

  const sanitizeInput = str => str.toLowerCase().replace(/[^a-z']/g, '');
  const stripApostrophes = str => str.replace(/'/g, '');

  document.getElementById('check-btn').addEventListener('click', () => {
    const raw1 = document.getElementById('word1').value.trim();
    const raw2 = document.getElementById('word2').value.trim();
    const resultEl = document.getElementById('result');
    const disclaimerEl = document.getElementById('disclaimer');
    const orderLink = document.getElementById('order-link');

    const clean1 = sanitizeInput(raw1);
    const clean2 = sanitizeInput(raw2);

    orderLink.style.display = 'none';
    disclaimerEl.textContent = '';

    if (clean1 !== raw1.toLowerCase() || clean2 !== raw2.toLowerCase()) {
      resultEl.textContent = '❌ Invalid characters detected. Please use only letters.';
      resultEl.style.color = '#ff4c4c';
      return;
    }

    const count1 = stripApostrophes(clean1).length;
    const count2 = stripApostrophes(clean2).length;

    if (count1 < 4 || count2 < 4) {
      resultEl.textContent = '❌ Words must be at least 4 letters long (excluding apostrophes).';
      resultEl.style.color = '#ff4c4c';
      return;
    }

    const isCompatible = areWordsCompatible(stripApostrophes(clean1), stripApostrophes(clean2));
    if (isCompatible) {
      resultEl.innerHTML = `✅ Compatible: '${raw1}' and '${raw2}' could make a great Ambigram!<br><br><span style="color: #00FF88;">LIMITED TIME: Use code <strong>SAVE50</strong> for $50 OFF your Custom Ambigram Order</span>`;
      resultEl.style.color = '#23ffe3';
      disclaimerEl.textContent = "Note: Compatibility means a design is most likely possible — but if your order just won't make a great Ambigram, Mr. Upsidedown will reach out to you personally to discuss alternatives.";
      orderLink.style.display = 'block';
    } else {
      resultEl.textContent = `❌ Incompatible: '${raw1}' and '${raw2}' are unlikely to work as an Ambigram.`;
      resultEl.style.color = '#ccc';
      disclaimerEl.textContent = "Note: Compatibility means a design is most likely possible — but if your order just won't make a great Ambigram, Mr. Upsidedown will reach out to you personally to discuss alternatives.";
    }
  });
});
